export const DOM_ID = {
  appRouteOutletWrapper: 'app-route-outlet-wrapper',
}

export const SESSION_STORAGE_KEY = {
  documentOCRResultStore: 'document-ocr-result-store',
}
